import React from "react";
import { connect } from "react-redux";
import { I18n } from "react-redux-i18n";
import alertify from "alertifyjs";
import "../components/styles/Alertify.css";
import "../components/styles/AlertifyTheme.css";
import "../components/styles/Alertify.min.css";
import "../components/styles/AlertifyTheme.min.css";
import * as actions from "../redux/actions/sessionActions";
import PasswordResetForm from "../components/PasswordResetForm";
import { isPasswordStrong } from "../utils/passwordValidation";

class PasswordReset extends React.Component {
  state = {
    password: "",
    passwordConfirm: "",
    touched: {
      password: false,
      passwordConfirm: false,
    },
    token: "",
  };

  componentDidMount() {
    this.setState({
      token: this.props.match.params.token,
    });
  }

  passwordsMismatch = () => {
    const { password, passwordConfirm } = this.state;
    return passwordConfirm.length > 0 && password !== passwordConfirm;
  };

  isSubmitDisabled = () => {
    const { password, passwordConfirm } = this.state;
    return (
      !password ||
      !passwordConfirm ||
      !isPasswordStrong(password) ||
      this.passwordsMismatch()
    );
  };

  onSubmit = async (e) => {
    e.preventDefault();

    this.setState({
      touched: { password: true, passwordConfirm: true },
    });

    if (this.isSubmitDisabled()) {
      if (this.passwordsMismatch()) {
        alertify.warning(I18n.t("warning_password_similar"));
      } else if (!isPasswordStrong(this.state.password)) {
        alertify.warning(I18n.t("warning_password_weak"));
      }
      return;
    }

    try {
      const result = await this.props.ChangePassword(
        this.state.token,
        this.state.password
      );
      if (result.ok) {
        this.props.history.push("/password_reset_successfull");
      } else {
        alertify.warning(I18n.t(result.error || "try_later"));
      }
    } catch (error) {
      console.log(error);
      alertify.warning(I18n.t("try_later"));
    }
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    const field = name === "passwordConfirm" ? "passwordConfirm" : "password";
    this.setState({ [field]: value });
  };

  handleBlur = (field) => () => {
    this.setState((prev) => ({
      touched: { ...prev.touched, [field]: true },
    }));
  };

  render() {
    const { password, passwordConfirm, touched } = this.state;

    return (
      <PasswordResetForm
        password={password}
        passwordConfirm={passwordConfirm}
        touched={touched}
        submitDisabled={this.isSubmitDisabled()}
        loading={this.props.loading}
        passwordWeak={password.length > 0 && !isPasswordStrong(password)}
        passwordsMismatch={this.passwordsMismatch()}
        onChange={this.handleChange}
        onBlur={this.handleBlur}
        onSubmit={this.onSubmit}
      />
    );
  }
}

function mapStateToProps(reducer) {
  return {
    loading: reducer.session.loading,
  };
}

const mapDispatchToProps = (dispatch) => ({
  ChangePassword: (token, password) =>
    dispatch(actions.changePassword({ token, password })),
});

export default connect(mapStateToProps, mapDispatchToProps)(PasswordReset);
